import {NewThirdPartyLeadNotificationDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";

/**
 * New third party lead notification class data.
 */
export default class NewThirdPartyLeadNotificationData {
	/**
	 * @param {string} leadId created lead id.
	 * @param {string} referenceNumber Lead reference number.
	 * @param {AuthenticatedEntity} creator 3rd party lead creator.
	 */
	constructor(readonly leadId: string,
		readonly referenceNumber: string,
		public readonly creator: AuthenticatedEntity) {}

	static fromJson(json: NewThirdPartyLeadNotificationDataApiDto): NewThirdPartyLeadNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new NewThirdPartyLeadNotificationData(
			json.leadId,
			json.referenceNumber,
			creator)
	}
}
